import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import React from 'react';
import { FormattedMessage } from 'react-intl';

const newTagStyle = { display: 'flex', flexDirection: 'row', alignItems: 'center' };

const ListingCardNewTag = () => {
  return (
    <Box sx={newTagStyle}>
      <Typography color="#fff" component="div" lineHeight={1} margin={0} variant="small">
        <FormattedMessage id="ListingCard.new" />
      </Typography>
    </Box>
  );
};

export default ListingCardNewTag;
